import type { ReactNode } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  AppBar,
  Box,
  Button,
  Container,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { useAuth } from '../context/AuthContext';

const NAV_LINKS = [
  { label: 'Campaigns', to: '/' },
  { label: 'Suppressions', to: '/suppressions' },
];

export default function AppShell({ children }: { children: ReactNode }) {
  const { user, signOutUser } = useAuth();
  const { pathname } = useLocation();

  return (
    <>
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>

      <AppBar position="static" color="primary">
        <Toolbar sx={{ gap: 2, flexWrap: 'wrap' }}>
          <Typography variant="h6" component="p" sx={{ mr: 2 }}>
            Rough Creek Campaigns
          </Typography>

          <Stack component="nav" aria-label="Main" direction="row" spacing={1} sx={{ flexGrow: 1 }}>
            {NAV_LINKS.map((link) => (
              <Button
                key={link.to}
                component={RouterLink}
                to={link.to}
                color="inherit"
                aria-current={pathname === link.to ? 'page' : undefined}
                sx={{
                  textDecoration: pathname === link.to ? 'underline' : 'none',
                  textUnderlineOffset: 6,
                }}
              >
                {link.label}
              </Button>
            ))}
          </Stack>

          <Tooltip title={user?.email ?? ''}>
            <Typography variant="body2" sx={{ display: { xs: 'none', sm: 'block' } }}>
              {user?.displayName ?? user?.email}
            </Typography>
          </Tooltip>
          <Button color="inherit" onClick={() => void signOutUser()}>
            Sign out
          </Button>
        </Toolbar>
      </AppBar>

      <Box component="main" id="main-content" tabIndex={-1}>
        <Container maxWidth="lg" sx={{ py: 4 }}>
          {children}
        </Container>
      </Box>
    </>
  );
}
